export const templateList = 'templateList';
export const templateIndustriesListKey = 'templateIndustriesListKey';
export const companiesListKey = 'companiesListKey';
export const tagsListKey = 'tagsListKey';
export const companiesAssignedListKey = 'companiesAssignedListKey';